import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StoryPlayback from '../components/StoryPlayback';
import axios from 'axios';
import AnalyticsService from '../services/AnalyticsService'

const PlayPage = () => {
  const { storyId } = useParams();

  const [story, setStory] = useState(null);
  const [assets, setAssets] = useState({
    characters: {},
    backgroundImage: null,
    backgroundMusic: null,
  });

  useEffect(() => {
    document.title = "Play Story";
  }, []);

  useEffect(() => {
    AnalyticsService.trackPageView(`/play/${storyId}`, `Play Page`);
  }, [storyId]);

  useEffect(() => {
    const fetchStory = async () => {
      try {
        const response = await axios.get(`/assets/${storyId}/story.json`);
        const storyData = response.data;

        const updatedAssets = {
          characters: {},
          backgroundImage: null,
          backgroundMusic: null,
        };

        // Update character images
        if (storyData.assets?.characters) {
          for (const [characterName, imagePath] of Object.entries(storyData.assets.characters)) {
            updatedAssets.characters[characterName] = `/assets/${storyId}/${imagePath.split('/').pop()}`;
          }
        }

        // Update background image
        if (storyData.assets?.backgroundImage) {
          updatedAssets.backgroundImage = `/assets/${storyId}/${storyData.assets.backgroundImage.split('/').pop()}`;
        }

        // Update background music
        if (storyData.assets?.backgroundMusic) {
          updatedAssets.backgroundMusic = `/assets/${storyId}/${storyData.assets.backgroundMusic.split('/').pop()}`;
        }

        setStory(storyData);
        setAssets(updatedAssets);
      } catch (error) {
        console.error('Error fetching story:', error);
      }
    };

    fetchStory();
  }, [storyId]);

  return story ? (
    <StoryPlayback
      storyId={storyId}
      story={story}
      onReplay={() => window.location.reload()}
      onNewStory={() => window.location.href = '/'}
      onBackPress={() => window.location.href = '/'}
      assets={assets}
    />
  ) : (
    <div>Loading story...</div>
  );
};

export default PlayPage;
